import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import InquiryListItem from '~/features/inquiry/components/InquiryListItem'
import { useInquiryList } from '~/features/inquiry/queries/useInquiry'
import { type Filters } from '~/features/inquiry/types/inquiry'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import NoData from '~/shared/components/NoData'
import Pagination from '~/shared/components/pagination/Pagination'
import theme from '~/shared/styles/theme'

function InquiryList() {
  const navigate = useNavigate()
  const [filters, setFilters] = useState<Filters>({
    page: 1,
    row_per_page: 10,
  })

  const { data: inquiry, isLoading: inquiryLoading } = useInquiryList(filters)

  if (inquiryLoading) return <LoadingScreen />

  const { list, pageInfo } = inquiry!

  const handleChangePage = (
    _event: React.ChangeEvent<unknown>,
    page: number,
  ) => {
    setFilters((prevFilters) => ({ ...prevFilters, page }))
  }

  const handleClickInquiryCreate = () => {
    navigate('/customer-service/inquiry/create')
  }

  return (
    <Wrapper>
      <HeaderBox>
        <InquiryButton onClick={handleClickInquiryCreate}>
          문의하기
        </InquiryButton>
      </HeaderBox>
      {list && list.length === 0 ? (
        <NoDataWrapper>
          <NoData />
        </NoDataWrapper>
      ) : (
        <>
          {list.map((item) => (
            <InquiryListItem key={item.id} data={item} />
          ))}
          <PaginationWrapper
            page={filters.page}
            count={pageInfo.max_page}
            onChange={handleChangePage}
          />
        </>
      )}
    </Wrapper>
  )
}

export default InquiryList

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  box-sizing: border-box;
  width: 100%;
  padding: 24px 36px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;

  @media ${theme.device.medium} {
    gap: 20px;
    padding: 20px 24px;
  }
`

const HeaderBox = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  width: 100%;

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 24px;
    align-items: flex-end;
  }
`

const InquiryButton = styled.button`
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  width: 141px;
  height: 58px;
  padding: 24px 12px;

  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 33px;
  color: white;

  background-color: #313634;
  border-radius: 54px;

  @media ${theme.device.medium} {
    width: 100%;
    height: 48px;

    font-size: 18px;
    line-height: 25px;

    border-radius: 50px;
  }
`

const PaginationWrapper = styled(Pagination)`
  display: flex;
  justify-content: center;
  margin: 0 auto;

  button {
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    line-height: 20px;
    color: #6b7280;
  }

  .Mui-selected {
    color: ${theme.colors.mint_3};
    background-color: transparent;
    border: none;
    border-radius: 10px;
  }
`

const NoDataWrapper = styled.div`
  width: 100%;
  height: 100%;
`
